import { Reducer } from "redux";
import type { ReducerAction } from "../../types/common";
import type { Cliente } from "../../types/cliente";
import type { Assinatura } from "../../types/assinatura";
import type { Plano } from "../../types/plano";

export const ClienteReducerTypes = {
  SET_LOADING_CLIENTE: "SET_LOADING_CLIENTE",
  SET_CLIENTE: "SET_CLIENTE",
  SET_CLIENTE_CONTRATANTE: "SET_CLIENTE_CONTRATANTE",
  SET_CLIENTE_DEPENDENTES: "SET_CLIENTE_DEPENDENTES",
  SET_CLIENTE_PLANO: "SET_CLIENTE_PLANO",
  SET_CLIENTE_ASSINATURA: "SET_CLIENTE_ASSINATURA",
} as const;

type SetLoadingClienteAction = ReducerAction<
  typeof ClienteReducerTypes.SET_LOADING_CLIENTE,
  boolean
>;

type SetClienteAction = ReducerAction<
  typeof ClienteReducerTypes.SET_CLIENTE,
  Cliente | null
>;

type SetClienteContratanteAction = ReducerAction<
  typeof ClienteReducerTypes.SET_CLIENTE_CONTRATANTE,
  Cliente
>;

type SetClienteDependentesAction = ReducerAction<
  typeof ClienteReducerTypes.SET_CLIENTE_DEPENDENTES,
  Cliente[]
>;

type SetClientePlanoAction = ReducerAction<
  typeof ClienteReducerTypes.SET_CLIENTE_PLANO,
  Plano
>;

type SetClienteAssinaturaAction = ReducerAction<
  typeof ClienteReducerTypes.SET_CLIENTE_ASSINATURA,
  Assinatura
>;

export type ClienteReducerActions =
  | SetLoadingClienteAction
  | SetClienteAction
  | SetClienteContratanteAction
  | SetClienteDependentesAction
  | SetClientePlanoAction
  | SetClienteAssinaturaAction;

type ClienteReducerState = {
  loading: boolean;
  cliente: Cliente | null;
  contratante?: Cliente;
  dependentes?: Cliente[];
  plano?: Plano;
  assinatura?: Assinatura;
};

const InitialState: ClienteReducerState = {
  loading: false,
  cliente: null,
  contratante: undefined,
  dependentes: undefined,
  plano: undefined,
  assinatura: undefined,
};

const ClienteReducer: Reducer<ClienteReducerState, ClienteReducerActions> = (
  state = InitialState,
  action
) => {
  switch (action.type) {
    case ClienteReducerTypes.SET_LOADING_CLIENTE:
      return { ...state, loading: action.payload };
    case ClienteReducerTypes.SET_CLIENTE:
      return { ...state, cliente: action.payload };
    case ClienteReducerTypes.SET_CLIENTE_CONTRATANTE:
      return { ...state, contratante: action.payload };
    case ClienteReducerTypes.SET_CLIENTE_DEPENDENTES:
      return { ...state, dependentes: action.payload };
    case ClienteReducerTypes.SET_CLIENTE_PLANO:
      return { ...state, plano: action.payload };
    case ClienteReducerTypes.SET_CLIENTE_ASSINATURA:
      return { ...state, assinatura: action.payload };
    default:
      return state;
  }
};

export default ClienteReducer;
